$(document).ready(function () {
  $(".see-more-link").click(function(e) {
    if ($(this).hasClass('fa-chevron-down')) {
      $(this).removeClass('fa-chevron-down');
      $(this).addClass('fa-chevron-up');
      $(this).siblings('.feedbox').height('auto');
    } else {
      $(this).removeClass('fa-chevron-up');
      $(this).addClass('fa-chevron-down');
      $(this).siblings('.feedbox').height('');
    }
  });
  $(".toggle-link").click(function() {
    if(!!$(this).data('custom-toggle')){
      $(this).parent().next('.toggle-container').toggle();
    }else{
      $(this).next('.toggle-container').toggle();
    }
    if ($(this).find('i.fa').hasClass('fa-caret-up')) {
      $(this).find('i.fa').removeClass('fa-caret-up');
      $(this).find('i.fa').addClass('fa-caret-down');
    } else {
      $(this).find('i.fa').removeClass('fa-caret-down');
      $(this).find('i.fa').addClass('fa-caret-up');
    }
  });

  $('.dashboard-duration #duration').change(function() {
    if($(this).val() == 'Custom date') {
      $('.custom-date').show();
    } else {
      $('.custom-date').hide();
    }
  });

  $('.dashboard .datepicker').change(function() {
    if (!!$(this).val()) {
      // nothing
    }
    else {
      switch ($(this).attr('name')) {
        case 'start_date_hidden':
          $('#start_date').val('');
          $('#start_date_hidden').val('');
          break;
        case 'end_date_hidden':
          $('#end_date').val('');
          $('#end_date_hidden').val('');
          break;
        default:
          break;
      }
    }
  });
});
